export class PanelConfiguration {
  width: number = 0;
  previewPanelHeight: number = 0;
  projectViewPanelHeight: number = 0;
}

export class RightPanelConfiguration {
  width: number = 0;
  costSummaryPanelHeight: number = 0;
  libraryViewPanelHeight: number = 0;
}

export class ApplicationLayoutConfiguration {
  leftPanel: PanelConfiguration = new PanelConfiguration();
  lastActiveTab: number = -1;
  projectViewPanel: ProjectViewPanel = new ProjectViewPanel();
}

export class ProjectViewPanel {
  autoHide: boolean = false;
  hide: boolean = false;
}

export class ProjectViewLayoutConfiguration {
  projectViewTemplate: number = 0;
  controllerIconTemplate: number = 0;
  hideShowTemplate: number = 0;
}


export class PreferenceResponse {
  applicationLastLayout: ApplicationLayoutConfiguration = new ApplicationLayoutConfiguration(); 
  projectViewLastLayout: ProjectViewLayoutConfiguration = new ProjectViewLayoutConfiguration(); 
}
